import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

let cachedSettings = null;
let listeners = [];

export const useSiteSettings = () => {
  const [settings, setSettings] = useState(cachedSettings || {});

  useEffect(() => {
    const update = (s) => setSettings(s);
    listeners.push(update);

    if (!cachedSettings) {
      axios
        .get(`${API_URL}/api/settings`)
        .then(({ data }) => {
          cachedSettings = data.settings || {};
          listeners.forEach((cb) => cb(cachedSettings));
        })
        .catch(() => {
          cachedSettings = {};
        });
    }

    return () => {
      listeners = listeners.filter((cb) => cb !== update);
    };
  }, []);

  return settings;
};

export const invalidateSettingsCache = () => {
  cachedSettings = null;
};
